import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-email-verification',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule],
  templateUrl: './email-verification.component.html',
  styleUrls: ['./email-verification.component.css'],
})
export class EmailVerificationComponent implements OnInit {
  verificationForm: FormGroup;
  email: string = '';
  isRegistration: boolean = true;
  isSubmitting: boolean = false;
  errorMessage: string = '';
  verificationSuccess: boolean = false;
  successMessage: string = '';

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.verificationForm = this.formBuilder.group({
      code: ['', [Validators.required, Validators.pattern(/^[0-9]{6}$/)]],
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.email = params['email'] || '';
      this.isRegistration = params['type'] !== 'change';

      if (!this.email) {
        this.router.navigate(['/']);
      }
    });
  }

  verifyEmail(): void {
    if (this.verificationForm.invalid) {
      return;
    }

    this.isSubmitting = true;
    this.errorMessage = '';

    const verificationData = {
      email: this.email,
      code: this.verificationForm.value.code,
    };

    this.authService.verifyEmail(verificationData).subscribe({
      next: (response) => {
        this.isSubmitting = false;
        this.verificationSuccess = true;
        this.successMessage = this.isRegistration
          ? 'Your email has been successfully verified! You can now log in to your account.'
          : 'Your email has been successfully verified!';

        setTimeout(() => {
          this.router.navigate(['/login'], {
            queryParams: { verified: 'true' },
          });
        }, 3000);
      },
      error: (error) => {
        this.isSubmitting = false;
        this.errorMessage =
          error.message || 'Verification failed. Please try again.';
      },
    });
  }
}
